import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Material } from 'src/app/models/material.model';

export interface MaterialState extends EntityState<Material> {
  finalProductId: number | null;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'material' })
export class MaterialStore extends EntityStore<MaterialState> {
  constructor() {
    super({ finalProductId: null });
  }

  updateMaterials(materials: Material[], finalProductId: number) {
    this.set(materials); // Store the materials
    this.update({ finalProductId }); // Update the finalProductId in the store state
  }
}
